import { postFunctionJson } from "./functionHttp";

export async function logAuditEvent(firebaseUser, payload = {}) {
  if (!firebaseUser) return;

  const authToken = await firebaseUser.getIdToken(true);
  const response = await postFunctionJson(
    "https://us-central1-deliveryapp-c1bf2.cloudfunctions.net/logAuditEvent",
    {
      authToken,
      body: {
        authToken,
        ...payload,
      },
    }
  );

  const data = await response.json().catch(() => ({}));
  if (!response.ok || data?.success === false) {
    throw new Error(data?.error || "Failed to log audit event.");
  }

  return data;
}
